import React from "react";
import PropTypes from "prop-types";
import { AlertPopUp, AlertPopUpPrimary } from "./styles";

export function AlertMessage(props) {
  return (
    <AlertPopUp
      title={props.title}
      visible={props.visible}
      onCancel={props.onCancel}
      width={props.width}
      cancelText="CLOSE"
    >
      {props.children}
    </AlertPopUp>
  );
}

AlertMessage.propTypes = {
  children: PropTypes.any,
  onCancel: PropTypes.func,
  title: PropTypes.string,
  visible: PropTypes.bool,
  width: PropTypes.any
}

export function CancelAlert(props) {
  return (
    <AlertPopUpPrimary
      title={props.title}
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      width={props.width}
      cancelText="No,take me back"
      okText="CONTINUE"
    >
      {props.children}
    </AlertPopUpPrimary>
  );
}

CancelAlert.propTypes = {
  children: PropTypes.any,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  title: PropTypes.string,
  visible: PropTypes.bool,
  width: PropTypes.any
}
